/* eslint-disable react/no-array-index-key */

/* eslint-disable @typescript-eslint/no-explicit-any */
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import senitize, { defaultSchema } from 'rehype-sanitize';

import { convertToNewLine } from '../../core/helpers';
import LinkRenderer from '../LinkRenderer/LinkRenderer';

interface IProps {
  className?: string;
  components?: any;
  children?: any;
}

const schema = {
  ...defaultSchema,
  tagNames: [...(defaultSchema.tagNames || []), 'video', 'source'],
  attributes: {
    ...defaultSchema.attributes,
    video: ['controls', 'src', 'width', 'height', 'poster'],
    source: ['src', 'type'],
  },
};

const tags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p'];

const MarkdownElement = (Tag: any) =>
  function Component({ node, children, ...props }: any) {
    return <Tag {...props}>{convertToNewLine(children)}</Tag>;
  };

function Markdown({ className, components, children }: IProps) {
  return (
    <ReactMarkdown
      className={`${className ? `${className}` : ''}`}
      components={{
        a: LinkRenderer,
        ...Object.fromEntries(tags.map((tag) => [tag, MarkdownElement(tag)])),
        ...components,
      }}
      rehypePlugins={[rehypeRaw, [senitize, schema]]}
    >
      {children}
    </ReactMarkdown>
  );
}

export default Markdown;
